// extracted by mini-css-extract-plugin
module.exports = {"Container":"DealerCard_Container__1w-Ui","DealerCard":"DealerCard_DealerCard__jRl6t"};